// Import all article images here
import giftcards from '../images/giftcards.jpg';
import devices from '../images/devices.jpg';
import spamEmails from '../images/spam-emails.jpg';
import cryptocurrencies from '../images/cryptocurrencies.jpg';
import ransomware from '../images/ransomware.jpg';
import hacker from '../images/hacker-guy-fawkes.jpg';
import aiagent from '../images/friendly-ai-agent.jpg';
import pii from '../images/personal-information.jpg';

// Export a mapping object with image names as keys
const articleImages = {
  giftcards: giftcards,
  devices: devices,
  spamEmails: spamEmails,
  cryptocurrencies: cryptocurrencies,
  ransomware: ransomware,
  hacker: hacker,
  aiagent: aiagent,
  pii: pii,
};

export default articleImages;
